"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalFooter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _clamp = require("../utils/_clamp");
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["children", "className", "contentRef", "resizable", "updateStyle", "modalContentId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CSS_BLOCK = 'sapcnqr-modal';
const RESIZE_STEP_SIZE = 16;
const addChildProps = (classnames, {
  displayName
}, childProps) => {
  if (displayName === 'Button') {
    return {
      className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__button`, {
        [`${CSS_BLOCK}__button--${childProps.size}`]: childProps.size && childProps.size !== 'lg'
      }, childProps.className)
    };
  }
  return {};
};
const ModalFooter = exports.ModalFooter = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      children,
      className,
      contentRef,
      resizable,
      updateStyle,
      modalContentId
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const [isDragging, setIsDragging] = (0, _react.useState)(false);
  const [position, setPosition] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  const dialogClientRect = contentRef?.current?.getBoundingClientRect();
  const getDialogNode = () => document?.getElementById(modalContentId);
  const contentClientRect = () => getDialogNode()?.getBoundingClientRect();
  const getDialogWidth = () => getDialogNode()?.offsetWidth || dialogClientRect?.width || 0;
  const getDialogHeight = () => getDialogNode()?.offsetHeight || dialogClientRect?.height || 0;
  const getContentTop = () => contentClientRect()?.top || 0;
  const getContentBottom = () => contentClientRect()?.bottom || 0;
  const getContentLeft = () => contentClientRect()?.left || 0;
  const getContentRight = () => contentClientRect()?.right || 0;
  const getContentHeight = () => contentClientRect()?.height || 0;
  const getContentWidth = () => contentClientRect()?.width || 0;
  const classnames = _bind.default.bind(_Modal.default);
  const footerClasses = classnames(`${CSS_BLOCK}__footer`, className);
  const minResizableWidth = Math.max(resizable?.minWidth || 0, 200);
  const maxResizableWidth = Math.min(resizable?.maxWidth || 999999, 99999);
  const minResizableHeight = Math.max(resizable?.minHeight || 0, 200);
  const maxResizableHeight = Math.min(resizable?.maxHeight || 999999, 99999);
  const onMouseDown = (0, _react.useCallback)(e => {
    e?.persist?.();
    if (e.button !== 0) {
      return;
    }
    if (typeof resizable?.onDragStart === 'function') {
      resizable.onDragStart(e);
    }
    setIsDragging(true);
    setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      startX: e.pageX,
      startY: e.clientY,
      startWidth: getDialogWidth(),
      startHeight: getDialogHeight()
    }));
  });
  const onKeyDown = e => {
    e?.persist?.();
    const resizeStepSize = e.shiftKey ? 5 * RESIZE_STEP_SIZE : RESIZE_STEP_SIZE;
    switch (e.keyCode) {
      case _keycode.default.codes.left:
        {
          e.preventDefault();
          let reducedWidth = getDialogWidth() - resizeStepSize;
          reducedWidth = (0, _clamp.clamp)(reducedWidth, minResizableWidth, maxResizableWidth);
          updateStyle?.({
            width: `${reducedWidth}px`,
            height: `${getDialogHeight()}px`
          });
          setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            width: reducedWidth
          }));
          break;
        }
      case _keycode.default.codes.right:
        {
          e.preventDefault();
          let increasedWidth = getDialogWidth() + Math.min(resizeStepSize, window.innerWidth - getContentRight());
          increasedWidth = (0, _clamp.clamp)(increasedWidth, minResizableWidth, maxResizableWidth);
          updateStyle?.({
            width: `${increasedWidth}px`,
            height: `${getDialogHeight()}px`
          });
          setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            width: increasedWidth
          }));
          break;
        }
      case _keycode.default.codes.up:
        {
          e.preventDefault();
          let reducedHeight = getDialogHeight() - resizeStepSize;
          reducedHeight = (0, _clamp.clamp)(reducedHeight, minResizableHeight, maxResizableHeight);
          updateStyle?.({
            height: `${reducedHeight}px`,
            width: `${getDialogWidth()}px`
          });
          setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            height: reducedHeight
          }));
          break;
        }
      case _keycode.default.codes.down:
        {
          e.preventDefault();
          let increasedHeight = getDialogHeight() + Math.min(resizeStepSize, window.innerHeight - getContentBottom());
          increasedHeight = (0, _clamp.clamp)(increasedHeight, minResizableHeight, maxResizableHeight);
          updateStyle?.({
            height: `${increasedHeight}px`,
            width: `${getDialogWidth()}px`
          });
          setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            height: increasedHeight
          }));
          break;
        }
      default:
    }
    if (typeof resizable?.onKeyDown === 'function') {
      resizable.onKeyDown(e);
    }
  };
  (0, _react.useEffect)(() => {
    if (!resizable) return;
    // update dialog size if resizable values change
    const width = `${(0, _clamp.clamp)(resizable?.width, minResizableWidth, maxResizableWidth)}px` || getDialogWidth();
    const height = `${(0, _clamp.clamp)(resizable?.height, minResizableHeight, maxResizableHeight)}px` || getDialogHeight();
    updateStyle?.({
      width,
      height
    });
  }, [resizable?.width, resizable?.height, minResizableWidth, maxResizableWidth, minResizableHeight, maxResizableHeight]);
  const clip = () => {
    let width = getDialogWidth();
    let height = getDialogHeight();
    if (getContentTop() + getContentHeight() > window.innerHeight) {
      height = (0, _clamp.clamp)(window.innerHeight - getContentTop(), minResizableHeight, window.innerHeight);
      height = `${height}px`;
    }
    if (getContentLeft() + getContentWidth() > window.innerWidth) {
      width = (0, _clamp.clamp)(window.innerWidth - getContentLeft(), minResizableWidth, window.innerWidth);
      width = `${width}px`;
    }
    updateStyle?.({
      width,
      height
    });
  };
  (0, _useUniversalLayoutEffect.default)(() => {
    if (!resizable) return () => {};
    // update dialog size if children/content change(s).
    // This ensures that if initial dimensions are not set
    // and the the modal contents go beyond
    // the visible screen, we reset it to fit the screen size.
    const clippingTimer = setTimeout(() => {
      clip();
    }, 300);
    return () => {
      clearTimeout(clippingTimer);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (!resizable) return;
    // update dialog size if children/content change(s).
    // This ensures that if initial dimensions are not set
    // and the new children/content causes the modal to go beyond
    // the visible screen, we reset it to fit the screen size.
    clip();
  }, [children]);
  (0, _react.useEffect)(() => {
    const onMouseMove = e => {
      e?.persist?.();
      const x = e.pageX;
      const y = e.clientY;
      let newWidth = position.startWidth + x - position.startX;
      const maxWidth = Math.min(maxResizableWidth, window.innerWidth - getContentLeft());
      newWidth = (0, _clamp.clamp)(newWidth, minResizableWidth, maxWidth);
      let newHeight = position.startHeight + y - position.startY;
      const maxHeight = Math.min(maxResizableWidth, window.innerHeight - getContentTop());
      newHeight = (0, _clamp.clamp)(newHeight, minResizableHeight, maxHeight);
      updateStyle?.({
        height: `${newHeight}px`,
        width: `${newWidth}px`
      });
    };
    const onMouseUp = e => {
      e?.persist?.();
      setIsDragging(false);
      if (typeof resizable?.onDragEnd === 'function') {
        resizable.onDragEnd(e);
      }
    };
    if (isDragging) {
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
    }
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, [isDragging, position, resizable]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-bind
    _react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
      value: addChildProps.bind(null, classnames)
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
      className: footerClasses,
      ref: ref
    }), children, resizable && /*#__PURE__*/_react.default.createElement("span", {
      "aria-label": resizable.handleLabel,
      onMouseDown: onMouseDown,
      onKeyDown: onKeyDown,
      role: "button",
      tabIndex: "0",
      className: classnames(`${CSS_BLOCK}__resize-handle`)
    })))
  );
});
ModalFooter.displayName = 'Modal.Footer';
ModalFooter.propTypes = {
  /** Content of the modal footer. */
  children: _propTypes.default.node,
  /** Custom classes to add to the footer’s `<div>` tag. */
  className: _propTypes.default.string,
  /** @ignore */
  contentRef: _propTypes.default.object,
  /** @ignore */
  resizable: _propTypes.default.shape({
    handleLabel: _propTypes.default.string.isRequired,
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    maxHeight: _propTypes.default.number,
    maxWidth: _propTypes.default.number,
    minHeight: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** @ignore */
  updateStyle: _propTypes.default.func,
  /** @ignore */
  modalContentId: _propTypes.default.string
};
var _default = exports.default = ModalFooter;